import React, { PropTypes, Component } from 'react'

import SearchModalNotePayment from 'components/SearchModalNotePayment'

class NotePayments extends Component {
  
  constructor(props) {
    super(props)

    this.state = {
      openSearch: false,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.id !== this.props.params.id) {
      this.setState({
        openSearch: false,
      })
    }
  }

  _openSearch = () => {
    this.setState({
      openSearch: true,
    })
  }

  _hideSearch = () => {
    this.setState({
      openSearch: false,
    })
  }

  _renderSearch() {
    const { openSearch } = this.state

    if (!openSearch) {
      return null
    }

    return (
      <SearchModalNotePayment handleClose={this._hideSearch} />
    )
  }

  render() {
    const { children } = this.props

    return (
      <div>
        { React.cloneElement(children, {onSearchForm: this._openSearch }) }
        {this._renderSearch()}
      </div>
    )
  }
}

NotePayments.propTypes = {
  children: PropTypes.any,
  dispatch: PropTypes.func,
}

export default NotePayments



// WEBPACK FOOTER //
// ./src/containers/NotePayments/index.js